<div class="navbar-container">

	<mat-toolbar class="navbar" color="primary">

		<div style="display: flex; flex-flow: row nowrap; color: var(--mainColor); align-items: center; gap: 1em;">

			<button
				mat-icon-button
				style="color: white;"
				(click)="snav.toggle()"
			>
				<mat-icon>{{ environment.texts.navbarMenuIcon.icon }}</mat-icon>
			</button>

			<a class="navbar-brand" [routerLink]="['/']" title="Startseite">
				<span style="font-size: larger;">
					{{ environment.texts.navbarCustomer.label }}
				</span>
			</a>
		</div>

		<button
			mat-button
			[matMenuTriggerFor]="userMenu"
			style="color: var(--customWhite)"
		>
	<app-avatar-circle [ebeId]="user.ebeId" size="sm" class="navbar-avatar"></app-avatar-circle>
	<span class="userid">{{nameShown}}</span>
	</button>

	</mat-toolbar>

	<mat-menu #userMenu="matMenu" xPosition="before" yPosition="above" [overlapTrigger]="false">

		<a mat-menu-item [routerLink]="['/Konto/Profil']">
			<mat-icon>{{ environment.texts.konto.icon }}</mat-icon>
			<span>{{ environment.texts.konto.label }}</span>
		</a>
		<a mat-menu-item (click)="disconnect()">
			<mat-icon>{{ environment.texts.abmelden.icon }}</mat-icon>
			<span>{{ environment.texts.abmelden.label }}</span>
		</a>

	</mat-menu>


	<mat-sidenav-container class="navbar-sidenav-container">

		<mat-sidenav
			#snav
			[opened]="!mobileQuery.matches"
			[mode]="mobileQuery.matches ? 'over' : 'side'"
			[fixedInViewport]="mobileQuery.matches"
			fixedTopGap="56"
			class="sidenav"
		>

			<div class="groupLinksColumn">

				<div>

					<div class="imgLogo">

						<a
							[routerLink]="['/']"
							title="Startseite"
						>
							<img
								[src]="logoSrc || 'assets/logo.png'"
								style="max-width: 270px; mix-blend-mode: darken;"
							>
						</a>

					</div>

					<div>

						<a
							[routerLink]="['']"
							class="rowLink"
							routerLinkActive="activeLink"
							[routerLinkActiveOptions]="{ exact: true }"
						>
							<mat-icon mat-list-icon>{{ environment.texts.startseite.icon }}</mat-icon>
							<span>{{ environment.texts.startseite.label }}</span>
						</a>

						@if( environment.features.statistik ) {
							<a
								[routerLink]="['/Statistik']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.statistik.icon }}</mat-icon>
								<span>{{ environment.texts.statistik.label }}</span>
							</a>
						}

						<a
							[routerLink]="['/Dokumente']"
							class="rowLink"
							routerLinkActive="activeLink"
						>
							<mat-icon mat-list-icon>{{ environment.texts.dokumente.icon }}</mat-icon>
							<span>{{ environment.texts.dokumente.label }}</span>
						</a>

						@if( environment.features.datenpflege && !mobileQuery.matches && ( bAdmin || user.gruppen.includes( UserRoles.MITGLIED_DATENPFLEGE ) )  ) {
							<a
								[routerLink]="['/Datenpflege']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.datenpflege.icon }}</mat-icon>
								<span>{{ environment.texts.datenpflege.label }}</span>
							</a>
						}

						@if( !bAdmin && user.gruppen.includes( UserRoles.MITGLIED_ADMIN ) ) {
							<a
								[routerLink]="['/Mitgliedsdaten']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.eigeneDaten.icon }}</mat-icon>
								<span>{{ environment.texts.eigeneDaten.label }}</span>
							</a>
						}

                                                @if( environment.features.export && ( bAdmin || user.gruppen.includes( UserRoles.MITGLIED_DATENEXPORT ) ) ) {
                                                        <a
                                                                [routerLink]="['/Export']"
                                                                class="rowLink"
                                                                routerLinkActive="activeLink"
                                                        >
                                                                <mat-icon mat-list-icon>{{ environment.texts.export.icon }}</mat-icon>
                                                                <span>{{ environment.texts.export.label }}</span>
                                                        </a>
                                                }



                                                <a
                                                        [routerLink]="['/News']"
                                                        class="rowLink"
                                                        routerLinkActive="activeLink"
						>
							<mat-icon mat-list-icon>{{ environment.texts.news.icon }}</mat-icon>
							<div class="textAndChip">
								<span>{{ environment.texts.news.label }}</span>
								@if( newNews ) {
									<span class="chipInfoNew">
										{{newNews}}
									</span>
								}
							</div>
						</a>

						<a
							(click)="setCalendarType(false)"
							[routerLink]="['/Veranstaltungen']"
							class="rowLink"
							routerLinkActive="activeLink"
							[routerLinkActiveOptions]="{ exact: true }"
						>
							<mat-icon mat-list-icon>{{ environment.texts.veranstaltungen.icon }}</mat-icon>
							<span>{{ environment.texts.veranstaltungen.label }}</span>
						</a>

						@if( environment.features.austausch ) {

							@if( environment.features.austauschOnlyVisibleWhenCategorySelected == false) {

								<a
									[routerLink]="['/Austausch']"
									(click)="resetCategories()"
									class="rowLink"
									routerLinkActive="activeLink"
								>
									<mat-icon mat-list-icon>{{ environment.texts.austausch.icon }}</mat-icon>

									<div class="textAndChip">
										<span>{{ environment.texts.austausch.label }}</span>
										@if( newDocuments ) {
											<span class="chipInfoNew">
												{{newDocuments}}
											</span>
										}
									</div>

								</a>

								@for( category of submenuCategories; track category.id ) {
									<a
										[routerLink]="['/Austausch']"
										[queryParams]="{ typ: category.id }"
										class="rowLink subcategory"
										routerLinkActive="activeLink"
									>
										<mat-icon mat-list-icon>subdirectory_arrow_right</mat-icon>
										<span>{{ category.name }}</span>
									</a>
								}

							}
						}

						@if( environment.features.kommunikation ) {

							<a
								[routerLink]="['/Mitgliederaustausch']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.messages.icon }}</mat-icon>

								<div class="textAndChip">
									<span>{{ environment.texts.messages.label }}</span>
									@if( newChats ) {
										<span class="chipInfoNew">
											{{newChats}}
										</span>
									}
								</div>

							</a>

						}

						@if( environment.features.briefegenerierung ) {
							<a
								[routerLink]="['/Briefegenerierung']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.briefegenerierung.icon }}</mat-icon>
								<div class="textAndChip">
								<span>{{ environment.texts.briefegenerierung.label }}</span>
								</div>
							</a>
						}

						@if( environment.features.bestand ) {
							<a
								[routerLink]="['/Bestandsauskunft']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.bestand.icon }}</mat-icon>

								<div class="textAndChip">
								<span>{{environment.texts.bestand.label}}</span>
								</div>

							</a>
						}

						@if( environment.features.antrag ) {
							<a
							[routerLink]="['/Antrag']"
							class="rowLink"
							routerLinkActive="activeLink"
							>
							<mat-icon mat-list-icon>{{ environment.texts.antrag.icon }}</mat-icon>

							<div class="textAndChip">
								<span>{{environment.texts.antrag.label}}</span>
							</div>

							</a>
						}

            @if( environment.features.vgv ) {
              <a
                [routerLink]="['/vgv']"
                class="rowLink"
                routerLinkActive="activeLink"
              >
                <mat-icon mat-list-icon>{{ environment.texts.antrag.icon }}</mat-icon>

                <div class="textAndChip">
                  <span>{{environment.texts.vgv.label}}</span>
                </div>

              </a>
            }
					</div>

				</div>

				@if( user.gruppen && user.gruppen.includes( UserRoles.MITGLIED_ADMIN ) ) {
					<div>

						<div class="administrationLabel">
							{{ environment.texts.verwaltung.label }}
						</div>

						<a
							[routerLink]="['/Benutzerverwaltung']"
							class="rowLink"
							routerLinkActive="activeLink"
						>
							<mat-icon mat-list-icon>{{ environment.texts.benutzer.icon }}</mat-icon>
							<span>{{ environment.texts.benutzer.label }}</span>
						</a>

					</div>
				}

				@if( bAdmin ) {

					<div>

						<div class="administrationLabel">
							{{ environment.texts.verwaltung.label }}
						</div>



						@if( environment.features.internalCalendar ) {

							<a
								(click)="setCalendarType(true)"
								[routerLink]="['/Interne_Veranstaltungen']"
								class="rowLink"
								routerLinkActive="activeLink"
								[routerLinkActiveOptions]="{ exact: true }"
							>
								<mat-icon mat-list-icon>{{ environment.texts.interneTermine.icon }}</mat-icon>
								<span>{{ environment.texts.interneTermine.label }}</span>
							</a>

						}

						<a
							[routerLink]="['/Mitgliederverwaltung']"
							class="rowLink"
							routerLinkActive="activeLink"
						>
							<mat-icon mat-list-icon>{{ environment.texts.mitglieder.icon }}</mat-icon>
							<span>{{ environment.texts.mitglieder.label }}</span>
						</a>

						<a
							[routerLink]="['/Benutzerverwaltung']"
							class="rowLink"
							routerLinkActive="activeLink"
						>
							<mat-icon mat-list-icon>{{ environment.texts.benutzer.icon }}</mat-icon>
							<span>{{ environment.texts.benutzer.label }}</span>
						</a>

						@if( environment.features.sparten ) {

							<a
								[routerLink]="['/Spartenverwaltung']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.sparten.icon }}</mat-icon>
								<span>{{ environment.texts.sparten.label }}</span>
							</a>

						}

						@if( environment.features.berichtsjahre ) {

							<a
								[routerLink]="['/Berichtsjahrverwaltung']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.berichtsjahre.icon }}</mat-icon>
								<span>{{ environment.texts.berichtsjahre.label }}</span>
							</a>

						}

						<a
							[routerLink]="['/Gruppenverwaltung']"
							class="rowLink"
							routerLinkActive="activeLink"
						>
							<mat-icon mat-list-icon>{{ environment.texts.gruppen.icon }}</mat-icon>
							<span>{{ environment.texts.gruppen.label }}</span>
						</a>


						<a
							[routerLink]="['/Rechtsdokumente']"
							class="rowLink"
							routerLinkActive="activeLink"
						>
							<mat-icon mat-list-icon>{{ environment.texts.legalArea.icon }}</mat-icon>
							<span>{{ environment.texts.legalArea.label }}</span>
						</a>

						@if( environment.features.payments ) {
							<a
								[routerLink]="['/Zahlungen']"
								class="rowLink"
								routerLinkActive="activeLink"
							>
								<mat-icon mat-list-icon>{{ environment.texts.payments.icon }}</mat-icon>
								<span>{{ environment.texts.payments.label }}</span>
							</a>

						}

					</div>
				}

			</div>

		</mat-sidenav>

		<mat-sidenav-content class="sidenav-content">

			<router-outlet></router-outlet>

			<app-footer />

		</mat-sidenav-content>

	</mat-sidenav-container>

</div>




